import UserEditComponent from 'src/components/features/superAdmin/userEditComponent';

const ListUserPage = () => <UserEditComponent />;

export default ListUserPage;
